import { useLogger as useLoggerCore } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';

export const useLogger = () => {
	return useLoggerCore('ecommerce');
};
